import { Panels } from "@msuite/ui/panels";
import Notes from "@/components/notes";
import type { VehiclePanelBaseProps } from "../../shared";
import { VehicleIntegrations } from "./vehicle-integrations";
import { VehiclePosition } from "./vehicle-position";
import { VehicleWebfleetInformation } from "./vehicle-webfleet-information";

export function VehicleGeneral({ vehicleId }: VehiclePanelBaseProps) {
	/** Render */
	return (
		<Panels>
			<Panels.Panel
				flex={1}
				className="bottom-space"
			>
				<VehicleIntegrations vehicleId={vehicleId} />
				<VehiclePosition
					vehicleId={vehicleId}
					key="vehicle-position"
				/>
				<VehicleWebfleetInformation
					vehicleId={vehicleId}
					key="vehicle-webfleet-information"
				/>
			</Panels.Panel>
			<Panels.Panel flex={2}>
				<Notes
					notesTable="vehicleNotes"
					identifier={vehicleId}
				/>
			</Panels.Panel>
		</Panels>
	);
}
